import { WithChildren } from '../types/utility';
import { Paper } from '@mui/material';
import styles from '../assets/css/spinner.module.css';
import { selectPrimaryColor, selectSecondaryColor } from '../app/slices/configuration.slice';
import { useAppSelector } from '../app/hooks';

type SpinnerProps = Partial<WithChildren>;

export const Spinner = ({ children }: SpinnerProps) => {
	const primaryColor = useAppSelector(selectPrimaryColor) as string;

	const paperSX = {
		backgroundColor: 'transparent',
		'&:before': {
			background: primaryColor
		},
		'&:after': {
			background: primaryColor
		}
	};

	return (
		<div className={styles['spinner']} style={{ borderRight: `10px solid ${primaryColor}` }}>
			<Paper elevation={0} className={styles['spinner-inner']} sx={paperSX}>
				<div className={styles['spinner-content']}>{children}</div>
			</Paper>
		</div>
	);
};

type DoubleSpinnerProps = Partial<WithChildren>;

export const DoubleSpinner = ({ children }: DoubleSpinnerProps) => {
	const secondaryColor = useAppSelector(selectSecondaryColor) as string;

	const paperSX = {
		backgroundColor: 'transparent',
		'&:before': {
			background: secondaryColor
		},
		'&:after': {
			background: secondaryColor
		}
	};

	return (
		<div className={styles['spinner-container']}>
			<Spinner>
				<div
					className={styles['inner-spinner-container']}
					style={{ borderRight: `10px solid ${secondaryColor}` }}
				>
					<Paper elevation={0} className={styles['spinner-inner-2']} sx={paperSX}>
						<div className={styles['spinner-inner2-reverse']}>
							<div className={styles['spinner-2-content']}>{children}</div>
						</div>
					</Paper>
				</div>
			</Spinner>
		</div>
	);
};
